  // 初始化所有Tab系统
  function initTabSystems() {
    document.querySelectorAll('.custom-tab-system').forEach(system => {
      const buttons = system.querySelectorAll('.tab-btn');
      const contents = system.querySelectorAll('.tab-content');
      // 默认显示第一个tab
      if (buttons.length > 0 && contents.length > 0) {
        buttons[0].classList.add('active');
        contents[0].classList.add('active');
      }
      // 为每个按钮添加点击事件
      buttons.forEach(button => {
        button.addEventListener('click', function() {
          const targetId = this.getAttribute('data-tab-target');
          // 移除当前系统中所有active类
          buttons.forEach(btn => btn.classList.remove('active'));
          contents.forEach(content => content.classList.remove('active'));
          // 为当前按钮和对应内容添加active类
          this.classList.add('active');
          document.getElementById(targetId).classList.add('active');
          // 为所有targetId值的按钮添加active类
          buttons.forEach(btn => {
            const btnTargetValue = btn.getAttribute('data-tab-target')
            if(targetId == btnTargetValue){
              btn.classList.add('active');
            }
          });
        });
      });
    });
  }
  // 普通加载和Turbo加载
  document.addEventListener('DOMContentLoaded', initTabSystems);
  document.addEventListener('turbo:load', initTabSystems);
